import { httpRequest } from "@services/http"

export class CommandGetJourneySteps {
    async run(journeyId: number) {
        const url = `${
          import.meta.env.VITE_API_PLATFORM_SERVICE_URL
        }api/v1/journeys/${journeyId}/steps/?as_tree=true`
        try {
            const response = await httpRequest<any>(url, {
            method: "GET"
            })
            return response
        } catch (error) {
            console.error("Error fetching data:", error)
            throw error
        }
    }
}